import type { Contact } from "@components/internal-contacts/_types/internalContacts.types";

import { emitChatNotification } from "../notification-center/chatNotificationBus";

export interface InternalMessageToastPayload {
  uid: string;
  senderName: string;
  companyId?: number | string | null;
  companyName?: string | null;
  text: string;
  contactId?: string | number | null;
  contact?: Contact | null;
}

export const emitInternalMessageToast = (payload: InternalMessageToastPayload): void => {
  if (payload.contactId == null) return;

  emitChatNotification({
    id: payload.uid,
    kind: "internal",
    companyId: payload.companyId ?? null,
    companyName: payload.companyName ?? null,
    title: payload.senderName,
    body: payload.text,
    chatName: payload.senderName,
    focusMessageUid: payload.uid,
    focusMessageText: payload.text,
    target: {
      type: "internal",
      contactId: String(payload.contactId),
      companyId: payload.companyId ?? null,
      contact: payload.contact ?? null,
    },
  });
};
